import { Component, inject, signal } from '@angular/core';
import { Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { MatToolbar } from '@angular/material/toolbar';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { Auth } from './shared/services/auth/auth';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, RouterLink, RouterLinkActive, MatToolbar, MatButton, MatIcon],
    templateUrl: './app.html',
    styleUrl: './app.scss',
})
export class App {
    private readonly auth = inject(Auth);
    private readonly router = inject(Router);

    protected readonly title = signal('front-importacao');

    /** A barra só aparece para quem está autenticado — na tela de login ela não faz sentido. */
    protected get autenticado(): boolean {
        return this.auth.possuiTokenValido();
    }

    protected sair(): void {
        this.auth.logout();
        this.router.navigate(['/login']);
    }
}
